export default __webpack_public_path__ + "static/media/map_marker.9fe87342.png";